export const GoogleMapsAPI = "AIzaSyAoVzr50f6wuOdLYUhUTvV7plTBWe6SxDs";
